import { useSelector } from "react-redux";
import AccountPopper from "src/components/button/WalletButton/AccountPopper";
import ConnectWalletButton from "src/components/button/WalletButton/ConnectWalletButton";

export default function WalletButton() {
  const accountAddress = useSelector((state) => state.accountSlice.address);

  return (
    <>
      {accountAddress && (
        <div
          id="ga4-trava-connected-wallet"
          style={{
            position: "absolute",
            zIndex: -100000,
            color: "transparent",
            width: "50px",
            wordBreak: "break-all",
          }}
        >
          {accountAddress}
        </div>
      )}
      {accountAddress ? <AccountPopper /> : <ConnectWalletButton />}
    </>
  );
}
